import workspaceQuery from '../../../graphql/queries/company/CompanyCompanyUserWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CompanyCompanyUserListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CompanyCompanyUserQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CompanyCompanyUserDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CompanyCompanyUserMutation.graphql';
import fragment from '../../../graphql/fragments/company/CompanyCompanyUserFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const CompanyCompanyUser: EntityType = {
  type: 'CompanyUser',
  title: 'Company Users',
  formTitle: 'Company User',
  formUrl: '/Company/CompanyUser/Details/',
  workspaceUrl: '/Company/CompanyUser/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'COMPANY_USERS',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default CompanyCompanyUser;
